"use client"
/* */
import { makeObservable, computed, action, observable } from 'mobx';
import { useSelector } from '../../../lib/mobx/useSelector.mjs';
import { sleep } from '../../../lib/promises/sleep.mjs';
import { useStatic } from '../../../lib/hooks/useStatic.mjs';

const duration = {
  pending: 1e3,
  succeeded: 1500,
  failed: 2e3
};
class ActionState {
  showFeedback;
  state = "isIdle";
  setPendingTimeout;
  error;
  isAsync = false;
  constructor() {
    makeObservable(this, {
      state: observable,
      updateState: action,
      isBusy: computed
    });
  }
  static useNew() {
    return useStatic(() => new ActionState());
  }
  updateState(newState) {
    this.state = newState;
  }
  useValue() {
    return useSelector(() => this.state, [this]);
  }
  useIsBusy() {
    return useSelector(() => this.isBusy, [this]);
  }
  get isBusy() {
    return this.state !== "isIdle";
  }
  onAsyncStart() {
    this.isAsync = true;
    this.updateState("isExecuting");
    this.setPendingTimeout = window.setTimeout(
      () => this.startPending(),
      duration.pending
    );
  }
  async onSucceeded() {
    await this.onDone();
  }
  async onFailed(error) {
    this.error = error ?? new Error("Unknown error");
    await this.onDone();
  }
  withFeedback(feedback) {
    this.showFeedback = feedback;
    return this;
  }
  async startFailedFeedback() {
    this.updateState("isFailed");
    await sleep(duration.failed);
    this.resetAfterDone();
  }
  async startSucceededFeedback() {
    this.updateState("isSucceeded");
    await sleep(duration.succeeded);
    this.resetAfterDone();
  }
  resetAfterDone() {
    this.updateState("isIdle");
    this.isAsync = false;
    this.error = void 0;
  }
  async onDone() {
    if (this.setPendingTimeout) {
      window.clearTimeout(this.setPendingTimeout);
    }
    if (this.error) {
      await this.startFailedFeedback();
    } else if (this.showFeedback !== false && (this.showFeedback || this.isAsync)) {
      await this.startSucceededFeedback();
    } else {
      this.resetAfterDone();
    }
  }
  startPending() {
    this.updateState("isPending");
  }
}

export { ActionState };
//# sourceMappingURL=ActionState.mjs.map
